module.exports = __webpack_public_path__ + "img/IMG_1869.906637f9.jpg";